<div [ngClass]="loading ? 'loading':'d-none'">
  <img src="assets/images/logo-cutcrew.jpg" class="ms-1 logo" width="100px" alt="">
</div>